// extracted by mini-css-extract-plugin
module.exports = {"container":"data_container__WAADn","title":"data_title__iZeJO","content":"data_content__Wamah","region":"data_region___Cq_t"};